import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16.038 8.878c0 4.575-3.139 8.931-7.574 10.014L8.02 19l-.445-.108C3.139 17.809 0 13.453 0 8.878V3.564L8.02 0l8.019 3.564v5.314z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#c1c7cd",
      d: "M8.019 1.565 1.474 4.474v4.364c0 4.036 2.793 7.811 6.545 8.727 3.753-.916 6.545-4.691 6.545-8.727V4.474L8.019 1.565zM6.565 13.201l-2.909-2.909 1.025-1.025 1.884 1.876 4.793-4.793 1.025 1.033-5.818 5.818z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "shield-check"}) } }